<template>
  <div
    class="selected-list-element-root"
    :class="{ 'selected-list-element-root--group': isGroup }"
    style="position: relative;"
  >
    <div :class="`grouped-element${isFirst ? '-first' : (isLast ? '-last' : '-center')}`" 
      :style="groupingMode ? 'padding-left: 18px;' : 'padding-left: 18px;'" v-if="!draggable"
    >
      <div class="row no-wrap items-start">
        <mosta-checkbox class="q-ml-xs my-check" 
          :disable="element.AlwaysSelected" v-if="isSelectable"
          v-model="elementModel.Selected"
          :label="element.GroupId && element.GroupId > 0 ? '' : getElementName">
        </mosta-checkbox>
        <!-- Если label пустой, рендерим span, чтобы по клику на надпись не убиралось выделение, если элемент сгруппирован -->
        <span v-if="element.GroupId && element.GroupId > 0" @click.stop class="text-grey-6" style="margin-left: 6px;">{{ getElementName }}</span>
      </div>
    </div> 
    <div v-else class="row justify-left full-width q-py-none no-wrap" 
      :style="!groupingMode && !(element.sub_items && element.sub_items.length) && isSelectable ? 'padding-left: 18px;' : ''">
      <q-badge v-if="!(element.sub_items && element.sub_items.length) && isSelectable && groupingMode" 
        :color="hovered || grouped ? 'primary' : 'white'" rounded
        style="min-width: 10px; min-height: 10px; max-width: 10px; max-height: 10px; border: 1px solid grey; cursor: pointer;"
        class="q-pa-none q-my-xs q-mr-sm"
        @mouseover="mouseover()" @mouseleave="mouseleave()" @click="clickBadge"
      />
      <dnd-reorder-element
        :id="undefined"
        :index="inputIndex"
        :highlight-condition="allowHoverAction"
        :hover-condition="() => false"
        :CtcDropCondition="allowHoverAction"
        :CtrDropCondition="() => false"
        :RtrDropCondition="() => false"
        :type="elDragType"
        :into-allowed="false"
        :grouping-mode="groupingMode"
        :callback-params="{ parent_id: parentId, isRoot: false, elType: 5, viewport: scrollViewport }"
        @changePosition="moveStoreItem"
        draggable="true"
        class="dnd-element display-ungroup-on-hover"
      >
        <q-btn
          v-if="element.sub_items && element.sub_items.length"
          class="q-my-none q-pa-xs text-left text-md ungroup-btn unset-items-center"
          style="position: absolute; top: 5px; right: 5px; z-index: 10;"
          no-caps align="left" size="xs" color="grey-8"
          icon="open_with" :aria-label="$t('choose_upcase')"
          @click.stop.prevent="onUnGroupClick(element.sub_items[0].GroupId)"
        >
          <q-tooltip :delay="300" anchor="top middle" self="center middle">
            {{ $t('ungroup') }}
          </q-tooltip>
        </q-btn>
        <mosta-checkbox class="q-ml-xs my-check" v-if="!(element.sub_items && element.sub_items.length) && isSelectable" 
          v-model="elementModel.Selected" :label="getElementName" :disable="element.AlwaysSelected"
        />
        <div class="row no-wrap display-delgroup-on-hover"
        v-else-if="isSelectable" 
        v-for="(sub, sub_index) in element.sub_items"
        :key="(parentIdx || '')+sub_index+'_g'+sub.GroupId+'_'+sub.compound_name">
        <!-- key: {{ (parentIdx || '')+sub_index+'_g'+sub.GroupId+'_'+sub.compound_name }} -->
          <selected-list-element
            :element="sub"
            :input-index="sub_index"
            :parent-id="undefined"
            :parent-name="''"
            :parent-idx="sub_index"
            :is-root="true"
            :grouping-mode="groupingMode"
            :is-first="sub_index === 0 || element.sub_items && !(element.sub_items[sub_index-1] as any).group_id && (sub as any).group_id"
            :is-last="element.sub_items && ((sub_index === element.sub_items.length-1) || 
              element.sub_items[sub_index+1] && !(element.sub_items[sub_index+1] as any).group_id && (sub as any).group_id)"
            :allow-hover-action="() => false"
            @changePosition="() => false"
            @changeSelection="onChildSelectionUpdate"
            @togglesChange="onTogglesChange"
            @rangeChange="onRangeChange"
            @unGroupClick="onUnGroupClick"
            @unGroupSingleClick="onUnGroupSingleClick"
            :scroll-viewport="scrollViewport"
          />
          <q-btn
            v-if="element.sub_items && element.sub_items.length"
            class="q-ml-sm text-left text-md delgroup-btn unset-items-center"
            style="margin-top: -2px;"
            no-caps align="left" size="xs" color="grey-8" flat round
            icon="close" :aria-label="$t('choose_upcase')"
            @click.stop.prevent="onUnGroupSingleClick((sub as ColumnListItem).GroupId, (sub as ColumnListItem).compound_id)"
          >
            <q-tooltip :delay="300" anchor="top middle" self="center middle">
              {{ $t('remove_from_group') }}
            </q-tooltip>
          </q-btn>
        </div>

        <div class="q-ml-lg" v-if="(element as ColumnSendWithOptions).ToggleArrays">
          <q-expansion-item dense flat :default-opened="false" 
                        :label="$t('options_label')" class="q-ma-none q-pa-none">
            <div v-for="(array, toggle_ai) in (element as ColumnSendWithOptions).ToggleArrays" :key="(parentIdx || '')+'_tar_'+toggle_ai">
              <div class="text-bold text-caption q-mb-xs q-ml-sm">{{ toggleArrayTypeToList(array.Type) }}</div>
              <q-toggle
                v-for="(toggle, toggle_i) in array.Toggles"
                :key="(parentIdx || '')+'_t_'+toggle_i"
                v-model="toggle.ToggledOn"
                class="q-mr-xs q-ml-none text-caption"
                checked-icon="add"
                color="primary"
                @update:model-value="(val: any) => { onToggleChange(val, toggle_i, toggle_ai) }"
                :label="(toggle.Type === 0 ? (toggle.Entity ? toggle.Entity.Name : '') : toggleTypeToList(toggle.Type))"
                size="xs"
                unchecked-icon="remove"
              />
            </div>
          </q-expansion-item>
        </div>

        <!-- ColumnDateRangeDto -->
        <div class="q-ml-lg" v-if="(element as ColumnSend).Descriptor === 3">
          <q-expansion-item dense flat :default-opened="false" :label="$t('options_label')" class="q-ma-none q-pa-none">
            <date-range-column-display-item v-model="elementModel" @update:model-value="onRangeChange" />
          </q-expansion-item>
        </div>
      </dnd-reorder-element>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
// @ts-ignore
import DndReorderElement from '@/components/dnd/DndReorderElement.vue';
import { DragItemTypes } from '@/components/dnd/ItemTypes';
import { ColumnSendToggleArrayMode, ColumnSendTypeDescriptor, ColumnToggleArrayType, ColumnToggleType } from '@/models/etc/types';
import { ColumnGroupItem } from '../base-list/interfaces/ListTypes';
import DateRangeColumnDisplayItem from '../basic/data-components/DateRangeColumnDisplayItem.vue';
import { ColumnDateRangeDto } from '../../../models/interfaces/entity-settings/columns/columns';
import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';

@Component({
  name: 'SelectedListElement',
  components: { DndReorderElement, DateRangeColumnDisplayItem, MostaCheckbox }
})
export default class SelectedListElement extends Vue {
    @Prop({ default: {} as ColumnGroupItem })
    element!: ColumnGroupItem
    @Prop({ default: false })
    draggable!: boolean
    @Prop({ default: undefined })
    scrollViewport?: any

    @Emit("changePosition") emitMoveItem(arg: any) { return arg; }
    @Emit("changeSelection") emitSelectionChanged(arg: any) { return arg }
    @Emit("addToGroup") emitAddToGroup(arg: any) { return arg }
    @Emit("removeFromGroup") emitRemoveFromGroup(arg: any) { return arg }
    @Emit("togglesChange") emitTogglesChange(arg: any) { return arg }
    @Emit("rangeChange") emitRangeChange(arg: any) { return arg }
    @Emit("unGroupClick") emitUnGroupClick(arg: any) { return arg }
    @Emit("unGroupSingleClick") emitUnGroupSingleClick(arg: any) { return arg }

    @Prop({ default: false })
    isRoot!: boolean
    @Prop({ default: false })
    groupingMode?: boolean
    @Prop({ default: false })
    isFirst?: boolean
    @Prop({ default: false })
    isLast?: boolean
    @Prop()
    allowHoverAction!: (dragParams: any, hoverParams: any) => boolean

    @Prop({ default: undefined })
    parentId!: number | undefined
    @Prop({ default: undefined })
    parentIdx!: string | undefined
    @Prop({ default: '' })
    parentName!: string
    @Prop({ default: -1 })
    inputIndex!: number

    // @ts-ignore
    elementModel: ColumnGroupItem = undefined

    hovered: boolean = false
    grouped: boolean = false

    @Watch('groupingMode')
    grouping_mode_watcher(val: boolean) {
      if (!val) {
        this.grouped = false
      }
    }

    mouseover() {
      this.hovered = true
    }

    mouseleave() {
      this.hovered = false
    }

    onUnGroupClick(arg: any) {
      this.emitUnGroupClick(arg)
    }

    onUnGroupSingleClick(groupId: any, compound_id: any) {
      this.emitUnGroupSingleClick({
        group_id: groupId,
        compound_id
      })
    }

    clickBadge() {
      this.grouped = !this.grouped
      if (this.grouped) {
        this.emitAddToGroup(this.grouped)
      } else {
        this.emitRemoveFromGroup(this.grouped)
      }
    }

    onToggleChange(val: boolean, el_ind: number, arr_ind: number) {
      const t_arr = this.element.ToggleArrays[arr_ind];

      const theonly_index = t_arr.Toggles.findIndex((el) => el.TheOnlyOption)
      if (theonly_index === el_ind) {
        if (val) {
          t_arr.Toggles.forEach((t, i) => {
            (i !== theonly_index) && (t.ToggledOn = false)
          })
        } else {
          if (t_arr.Mode === ColumnSendToggleArrayMode.NonEmpty) {
            t_arr.Toggles.forEach((t, i) => {
              (i !== theonly_index) && (t.ToggledOn = true)
            })
          }
        }
      } else {
        if (val && theonly_index >= 0) {
          t_arr.Toggles[theonly_index].ToggledOn = false
        } else {
          if (t_arr.Mode === ColumnSendToggleArrayMode.NonEmpty) {
            // check if there is any checked left; if no - check the only; if no theonly - check others
            if (t_arr.Toggles.findIndex(t => t.ToggledOn === true) < 0) {
              if (theonly_index >= 0) {
                t_arr.Toggles[theonly_index].ToggledOn = true
              } else {
                t_arr.Toggles.forEach((t, i) => {
                  (i !== el_ind) && (t.ToggledOn = true)
                })
              }
            }
          }
        }
      }

      this.onTogglesChange()
    }

    onTogglesChange() {
      this.emitTogglesChange(undefined)
    }

    onRangeChange(val: any) {
      this.emitRangeChange(val)
    }
    
    get elDragType() {
      return DragItemTypes.CARD_ROOT
    }
    
    // temporary data
    tempName: string = ''
    old_value: boolean | undefined = undefined

    @Watch('elementModel', { deep: true })
    onModelUpdate(arg: any, old_arg: any) {
      if (old_arg && (this.old_value === undefined || this.old_value !== arg.Selected)) {
        this.old_value = arg.Selected
        this.emitSelectionChanged(arg)
      }
    }

    onChildSelectionUpdate(arg: any) {
      this.emitSelectionChanged(arg)
    }

    // TODO: on toggle click emit signal and save model
    toggleArrayTypeToList(val: ColumnToggleArrayType) {
      switch (val) {
        case ColumnToggleArrayType.AddressLevelsShown:
          return this.$t('address_levels_seen')
        case ColumnToggleArrayType.AddressRoles:
          return this.$t('address_roles_seen')
        case ColumnToggleArrayType.JobStatusDisplay:
          return this.$t('status_display_method')
        case ColumnToggleArrayType.PersonLastChangeOptions:
          return this.$t('last_change_options')
        case ColumnToggleArrayType.ShowUnionClosely:
          return ""
        case ColumnToggleArrayType.ShowWorkersInJob:
          return ""
        default:
          return ""
      }
    }

    toggleTypeToList(val: ColumnToggleType) {
      switch (val) {
        case ColumnToggleType.AllAddressLevels:
          return this.$t('all_address_levels')
        case ColumnToggleType.AnyRole:
          return this.$t('any_rolw')
        case ColumnToggleType.ShowLastChanger:
          return this.$t('show_last_editor')
        case ColumnToggleType.StatusAsColor:
          return this.$t('color_status_method')
        case ColumnToggleType.StatusAsText:
          return this.$t('text_status_method')
        case ColumnToggleType.ShowUnionClosely:
          return this.$t('combine_clients_to_holding')
        case ColumnToggleType.ShowWorkersInJob:
          return this.$t('show_job_users')
        case ColumnToggleType.ShowChangesCount:
          return this.$t('total_changes')
        case ColumnToggleType.Entity:
        default:
          return ''+val
      }
    }

    created() {
      //
      this.elementModel = this.element as ColumnGroupItem
      this.old_value = this.elementModel.Selected
    }

    get isSelectable(): boolean {
      return this.element.Descriptor !== ColumnSendTypeDescriptor.Composite
    }

    /** Корневой root, который рендерит группу с зелёной полоской слева
     *  (draggable=true ветка с непустыми sub_items). Используется только для
     *  modifier-класса, который уменьшает margin-top у следующего sibling-root. */
    get isGroup(): boolean {
      return !!this.draggable
        && Array.isArray(this.element.sub_items)
        && this.element.sub_items.length > 0
    }

    get getElementName(): string {
      return (this.elementModel.Selected || !this.elementModel.Entity) ? 
      (this.element as ColumnGroupItem).compound_name : this.elementModel.Entity.Name
    }

    async moveStoreItem(params: any) {
      this.emitMoveItem(params)
    }

    @Watch('inputItems', { deep: true })
    updateItems() {
        // remember state
        // @ts-ignore
    }
}
</script>

<style lang="scss">
@mixin common-before {
  
  width: 3px;
  display: block;
  position: absolute;
  left: 4px;
  background-color:  #54b2a9;
  content: '';
}

.dnd-element {
  width: 100%;
}

/* Зазор для каждого корневого SelectedListElement (включая первый — от шапки «Колонки:»).
   Цель — визуально иметь ~12px между квадратами чекбоксов. Сам root высотой ~20px
   из-за line-height лейбла, под SVG (16px) ещё ~4px пустого пространства, поэтому
   margin-top подбирается с учётом этой «лишней» внутренней части. */
.selected-list-element-root {
  margin-top: 8px;
}

/* После группы (root с sub_items, рисующей зелёную полоску) визуально
   зазор смотрится больше за счёт нижней половины полоски и контента
   последнего sub-item, поэтому уменьшаем margin до 6px. */
.selected-list-element-root--group + .selected-list-element-root {
  margin-top: 6px;
}

/* Sub-items внутри группы (рендерятся внутри .row.display-delgroup-on-hover как flex-item'ы):
   margin-top на flex-item отодвинул бы sub-item по вертикали относительно close-кнопки в
   той же flex-row, а не относительно предыдущей обёртки. Поэтому сбрасываем margin-top
   корневого враппера sub-item, а зазор между sub-items даём на саму обёртку. */
.row.display-delgroup-on-hover .selected-list-element-root {
  margin-top: 0;
}

.row.display-delgroup-on-hover + .row.display-delgroup-on-hover {
  margin-top: 8px;
}

/* ::before растянут на 8px наружу враппера каждого sub-item с обеих стыкующихся сторон,
   чтобы перекрыть новый зазор между соседями без визуальных разрывов полоски.
   first/last сохраняют 10px на «своей» внешней стороне (середина крайнего чекбокса). */
.grouped-element {
  &-first::before {
    @include common-before;
    top: 10px;
    bottom: -8px;
  }

  &-center::before {
    @include common-before;
    top: -8px;
    bottom: -8px;
  }

  &-last::before {
    @include common-before;
    top: -8px;
    bottom: 10px;
  }
}

/* display-on-hover */
.display-ungroup-on-hover .ungroup-btn {
  visibility: hidden;
  opacity: 0;
  transition: opacity .2s;
}

.display-ungroup-on-hover:hover .ungroup-btn {
  visibility: visible;
  opacity: 1;
  transition: opacity .2s;
}
/* display-on-hover end */

/* display-on-hover */
.display-delgroup-on-hover .delgroup-btn {
  visibility: hidden;
  opacity: 0;
  transition: opacity .2s;
}

.display-delgroup-on-hover:hover .delgroup-btn {
  visibility: visible;
  opacity: 1;
  transition: opacity .2s;
}
/* display-on-hover end */

/* Размеры тоггла в em от шрифта самого узла. Общее правило шрифта в app.scss
   ставит 14px на дорожку и кружок, inherit возвращает их к размеру inner. */
.selected-list-element-root .q-toggle__track,
.selected-list-element-root .q-toggle__thumb {
  font-size: inherit;
}

</style>
